<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.name" placeholder="企业名称" style="width:300px;" icon="circle-close"
                    :on-icon-click="cleanFilter"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="getCompanies">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd">新增</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="companies" border highlight-current-row v-loading="listLoading" @row-click="rowClick" :row-class-name="tableRowClassName"
              style="width: 100%;">
      <el-table-column header-align="center" prop="name" label="企业名称" min-width="150">
      </el-table-column>
      <el-table-column header-align="center" prop="city" label="城市" width="80" :formatter="formatCity" align="center">
      </el-table-column>
      <el-table-column header-align="center" prop="address" label="企业地址" min-width="200">
      </el-table-column>
      <el-table-column header-align="center" prop="contactName" label="联系人" width="80" align="center">
      </el-table-column>
      <el-table-column header-align="center" prop="contactPhone" label="联系电话" width="130" align="center">
      </el-table-column>
      <!--<el-table-column header-align="center" prop="lng" label="经度" width="110" align="center">-->
      <!--</el-table-column>-->
      <!--<el-table-column header-align="center" prop="lat" label="纬度" width="110" align="center">-->
      <!--</el-table-column>-->
      <el-table-column header-align="center" prop="createdAt" label="创建时间" :formatter="formatCreateTime" width="120" align="center">
      </el-table-column>
      <el-table-column label="操作" width="150" align="center">
        <template scope="scope">
          <el-button size="small" @click.stop="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button type="danger" size="small" @click.stop="handleDel(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="total"
                     style="float:right;">
      </el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog title="编辑" v-model="editFormVisible" :close-on-click-modal="false">
      <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
        <el-form-item label="企业名称" prop="name">
          <el-input v-model="editForm.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="企业别名" prop="alias">
          <el-input v-model="editForm.alias" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="城市" prop="cityId">
          <el-select v-model="editForm.cityId" placeholder="请选择">
            <el-option
                    v-for="item in cities" :key="item.id"
                    :label="item.name"
                    :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="地址" prop="address">
          <el-input v-model="editForm.address" @blur="convertAddress2"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="contactName">
          <el-input v-model="editForm.contactName"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="contactPhone">
          <el-input v-model="editForm.contactPhone"></el-input>
        </el-form-item>
        <!--<el-form-item>-->
          <!--<baidu-map class="mapView" :center="editForm.center" :zoom="19" ak="bAouH2hDApj3TNU7dgK02jyx"-->
                     <!--:keyboard="false">-->
            <!--<bm-marker :position="editForm.center" :dragging="false" :offset="{width: 10, height: -10}" :icon="{url: 'http://api0.map.bdimg.com/images/marker_red_sprite.png', size: {width: 30, height: 30}}">-->
            <!--</bm-marker>-->
          <!--</baidu-map>-->
        <!--</el-form-item>-->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog title="新增" v-model="addFormVisible" :close-on-click-modal="false">
      <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
        <el-form-item label="企业名称" prop="name">
          <el-input v-model="addForm.name" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item label="企业别名" prop="alias">
          <el-input v-model="addForm.alias" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="城市" prop="cityId">
          <el-select v-model="addForm.cityId" placeholder="请选择">
            <el-option
                    v-for="item in cities" :key="item.id"
                    :label="item.name"
                    :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="地址" prop="address">
          <el-input v-model="addForm.address" @blur="convertAddress"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="contactName">
          <el-input v-model="addForm.contactName"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="contactPhone">
          <el-input v-model="addForm.contactPhone"></el-input>
        </el-form-item>
        <!--<el-form-item>-->
          <!--<baidu-map class="mapView" :center="addForm.center" :zoom="18" ak="bAouH2hDApj3TNU7dgK02jyx"-->
                     <!--:keyboard="false">-->
            <!--<bm-marker :position="addForm.center" :dragging="false" :offset="{width: 10, height: -10}" :icon="{url: 'http://api0.map.bdimg.com/images/marker_red_sprite.png', size: {width: 30, height: 30}}">-->
            <!--</bm-marker>-->
          <!--</baidu-map>-->
        <!--</el-form-item>-->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--查看界面-->
    <el-col :span="24">
      <el-tabs v-if="viewVisible">
        <el-tab-pane>
          <span slot="label"><span>企业用户管理</span></span>
          <el-col :span="24">
            <el-button size="small" type="primary" @click="handleAddUser" style="margin-left:20px;margin-bottom: 20px;">新增用户</el-button>
            <el-table :data="users" border highlight-current-row v-loading="usersLoading"
                      style="width: 100%;">
              <el-table-column header-align="center" align="center" prop="name" label="姓名" min-width="100">
              </el-table-column>
              <el-table-column header-align="center" prop="username" label="用户名" align="center" width="100">
              </el-table-column>
              <el-table-column header-align="center" prop="email" label="邮箱" min-width="130">
              </el-table-column>
              <el-table-column header-align="center" align="center" label="电话" prop="phone" width="150">
              </el-table-column>
              <el-table-column header-align="center" prop="createdAt" label="创建时间" :formatter="formatCreateTime" width="150" align="center">
              </el-table-column>
              <el-table-column header-align="center" align="center" prop="updatedAt" label="更新时间" :formatter="formatUpdateTime" width="150">
              </el-table-column>
              <el-table-column header-align="center" align="center" label="操作" width="200">
                <template scope="scope">
                  <el-button size="small" @click="handleEditUser(scope.$index, scope.row)">编辑</el-button>
                  <el-button type="danger" size="small" @click="handleDelUser(scope.$index, scope.row)">删除</el-button>
                  <el-button type="danger" size="small" @click="handleTick(scope.$index, scope.row)">踢出</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-tab-pane>
        <el-tab-pane>
          <span slot="label"><span>企业区域管理</span></span>
          <el-button size="small" type="primary" @click="handleAddGroup" style="margin-left:20px;margin-bottom: 20px;">新增区域</el-button>
          <el-col :span="24">
            <el-table :data="groups" border highlight-current-row v-loading="groupsLoading"
                      style="width: 100%;">
              <el-table-column header-align="center" align="center" prop="name" label="区域名称" min-width="100">
              </el-table-column>
              <el-table-column header-align="center" prop="createdAt" label="创建时间" :formatter="formatCreateTime" width="150" align="center">
              </el-table-column>
              <el-table-column header-align="center" align="center" prop="updatedAt" label="更新时间" :formatter="formatUpdateTime" width="150">
              </el-table-column>
              <el-table-column header-align="center" align="center" label="操作" width="150">
                <template scope="scope">
                  <el-button size="small" @click="handleEditGroup(scope.$index, scope.row)">编辑</el-button>
                  <el-button type="danger" v-if="scope.row.name != '默认区域'" size="small" @click="handleDelGroup(scope.$index, scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>

            <!--工具条-->
            <el-col :span="24" class="toolbar">
              <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange2" :page-size="10" :total="total2"
                             style="float:right;">
              </el-pagination>
            </el-col>
          </el-col>
        </el-tab-pane>
      </el-tabs>
    </el-col>

    <!--新增用户界面-->
    <el-dialog title="新增用户" v-model="addUserFormVisible" :close-on-click-modal="false">
      <el-form :model="addUserForm" label-width="80px" :rules="addUserFormRules" ref="addUserForm">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="addUserForm.username"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input type="password" v-model="addUserForm.password"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input v-model="addUserForm.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="addUserForm.email"></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="phone">
          <el-input v-model="addUserForm.phone"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addUserFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addUserSubmit" :loading="addUserLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--编辑用户界面-->
    <el-dialog title="编辑用户" v-model="editUserFormVisible" :close-on-click-modal="false">
      <el-form :model="editUserForm" label-width="80px" :rules="editUserFormRules" ref="editUserForm">
        <el-form-item label="用户名" prop="username">
          <el-input :disabled="true" v-model="editUserForm.username"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input type="password" v-model="editUserForm.password"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input v-model="editUserForm.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="editUserForm.email"></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="phone">
          <el-input v-model="editUserForm.phone"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editUserFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editUserSubmit" :loading="editUserLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--新增区域界面-->
    <el-dialog title="新增区域" v-model="addGroupFormVisible" :close-on-click-modal="false">
      <el-form :model="addGroupForm" label-width="80px" :rules="addGroupFormRules" ref="addGroupForm">
        <el-form-item label="区域名称" prop="name">
          <el-input v-model="addGroupForm.name"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addGroupFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addGroupSubmit" :loading="addGroupLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--编辑区域界面-->
    <el-dialog title="编辑区域" v-model="editGroupFormVisible" :close-on-click-modal="false">
      <el-form :model="editGroupForm" label-width="80px" :rules="editGroupFormRules" ref="editGroupForm">
        <el-form-item label="区域名称" prop="name">
          <el-input v-model="editGroupForm.name"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editGroupFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editGroupSubmit" :loading="editGroupLoading">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
  import util from '../../common/js/util'
  import moment from 'moment'
  import bcrypt from 'bcryptjs'
  import {BaiduMap, BmMarker} from 'vue-baidu-map'
  import {getCompanyList, getGroupList, checkUser, addGroup, removeGroup, editGroup, getCityList, addCompany, editCompany, removeCompany,getUserList, addUser, editUser,removeUser} from '../../api/api';

  export default {
    data() {
      var validateWordAndNumberAndChinese = (rule, value, callback) => {
        var jgpattern =/^[\u4e00-\u9fa5_（）\(\)a-zA-Z0-9]+$/;
        if(!jgpattern.test(value)){
          callback(new Error('请输入中文、字母、数字、圆括号或下划线'));
        } else {
          callback();
        }
      };
      var validateWordAndNumberAndSpaceAndChinese = (rule, value, callback) => {
        var jgpattern =/^[\u4e00-\u9fa5 _（）\(\)a-zA-Z0-9]+$/;
        if(!jgpattern.test(value)){
          callback(new Error('请输入中文、字母、数字、圆括号、空格或下划线'));
        } else {
          callback();
        }
      };
      var validateChinese = (rule, value, callback) => {
        var jgpattern =/^[\u4e00-\u9fa5]+$/;
        if(!jgpattern.test(value)){
          callback(new Error('请输入中文'));
        } else {
          callback();
        }
      };
      var validateWordAndNumber = (rule, value, callback) => {
        var jgpattern =/^[A-Za-z0-9]+$/;
        if(!jgpattern.test(value)){
          callback(new Error('请输入字母或数字'));
        } else {
          callback();
        }
      };
      var validateNumber = (rule, value, callback) => {
        var jgpattern =/^[+0-9]+$/;
        if(!jgpattern.test(value)){
          callback(new Error('请输入数字'));
        } else {
          callback();
        }
      };
      var validateNumberAndDot = (rule, value, callback) => {
        var jgpattern =/^[.0-9]+$/;
        if(!jgpattern.test(value)){
          callback(new Error('请输入数字或小数点'));
        } else {
          callback();
        }
      };
      var validateNumberAndComma = (rule, value, callback) => {
        var jgpattern =/^[,0-9]+$/;
        if(!jgpattern.test(value)){
          callback(new Error('请输入数字或半角逗号'));
        } else {
          callback();
        }
      };
      var checkUserExist = (rule, value, callback) => {
        checkUser(value).then((res) => {
          if (res.data == 0) {
            callback();
          } else {
            callback(new Error('用户名已存在'));
          }
        });
      };
      return {
        filters: {
          name: ''
        },
        companies: [],
        cities: [],
        roles: [],
        users: [],
        groups: [],
        total: 0,
        total2: 0,
        page: 1,
        page2: 1,
        listLoading: false,
        usersLoading: false,
        groupsLoading: false,

        editFormVisible: false,//编辑界面是否显示
        editLoading: false,
        editFormRules: {
          name: [
            {required: true, message: '请输入企业名称', trigger: 'blur'},
            { validator: validateWordAndNumberAndChinese, trigger: 'blur' }
          ],
          alias: [
            {required: true, message: '请输入企业别名', trigger: 'blur'},
            { validator: validateWordAndNumberAndChinese, trigger: 'blur' }
          ],
          cityId: [
            {required: true, message: '请选择城市', trigger: 'change'}
          ],
          address: [
            {required: true, message: '请输入企业地址', trigger: 'blur'},
            { validator: validateWordAndNumberAndSpaceAndChinese, trigger: 'blur' }
          ],
          contactName: [
            {required: true, message: '请输入联系人', trigger: 'blur'},
            { validator: validateChinese, trigger: 'blur' }
          ],
          contactPhone: [
            {required: true, message: '请输入联系方式', trigger: 'blur'},
            { validator: validateNumberAndComma, trigger: 'blur' }
          ]
        },
        //编辑界面数据
        editForm: {
          id: '',
          name: '',
          alias: '',
          cityId: '',
          address: '',
          lat: '',
          lng: '',
          center: {
            lat: 0,
            lng: 0
          },
          contactName: '',
          contactPhone: '',
        },

        addFormVisible: false,//新增界面是否显示
        addLoading: false,
        addFormRules: {
          name: [
            {required: true, message: '请输入企业名称', trigger: 'blur'},
            { validator: validateWordAndNumberAndChinese, trigger: 'blur' }
          ],
          alias: [
            {required: true, message: '请输入企业别名', trigger: 'blur'},
            { validator: validateWordAndNumberAndChinese, trigger: 'blur' }
          ],
          cityId: [
            {required: true, message: '请选择城市', trigger: 'change'}
          ],
          address: [
            {required: true, message: '请输入企业地址', trigger: 'blur'},
            { validator: validateWordAndNumberAndChinese, trigger: 'blur' }
          ],
          contactName: [
            {required: true, message: '请输入联系人', trigger: 'blur'},
            { validator: validateChinese, trigger: 'blur' }
          ],
          contactPhone: [
            {required: true, message: '请输入联系方式', trigger: 'blur'},
            { validator: validateNumberAndComma, trigger: 'blur' }
          ]
        },
        //新增界面数据
        addForm: {
          name: '',
          alias: '',
          cityId: '',
          address: '',
          lat: '',
          lng: '',
          center: {lng: 116.404, lat: 39.915},
          contactName: '',
          contactPhone: '',
        },
        viewVisible: false,
        selectedRow: {},

        addUserFormVisible: false,//新增用户界面是否显示
        addUserLoading: false,
        addUserFormRules: {
          name: [
            {required: true, message: '请输入姓名', trigger: 'blur'},
            { validator: validateChinese, trigger: 'blur' }
          ],
          username: [
            {required: true, message: '请选择用户名', trigger: 'blur'},
            { validator: validateWordAndNumber, trigger: 'blur' },
            { validator: checkUserExist, trigger: 'blur' },
          ],
          password: [
            {required: true, message: '请输入密码', trigger: 'blur'}
          ],
          email: [
            {required: true, type: 'email', message: '请输入邮箱', trigger: 'blur'}
          ],
          phone: [
            {required: true, message: '请输入电话', trigger: 'blur'},
            { validator: validateNumber, trigger: 'blur' }
          ],
        },
        //新增界面数据
        addUserForm: {
          name: '',
          username: '',
          password: '',
          email: '',
          phone: '',
          companyId: '',
        },

        editUserFormVisible: false,//编辑界面是否显示
        editUserLoading: false,
        editUserFormRules: {
          name: [
            {required: true, message: '请输入姓名', trigger: 'blur'},
            { validator: validateChinese, trigger: 'blur' }
          ],
          username: [
            {required: true, message: '请选择用户名', trigger: 'blur'},
            { validator: validateWordAndNumber, trigger: 'blur' }
          ],
//          password: [
//            {required: true, message: '请输入密码', trigger: 'blur'}
//          ],
          email: [
            {required: true, type: 'email', message: '请输入邮箱', trigger: 'blur'}
          ],
          phone: [
            {required: true, message: '请输入电话', trigger: 'blur'},
            { validator: validateNumber, trigger: 'blur' }
          ],
        },
        //编辑界面数据
        editUserForm: {
          id: '',
          name: '',
          username: '',
          password: '',
          email: '',
          phone: '',
          companyId: '',
        },

        addGroupFormVisible: false,//新增用户界面是否显示
        addGroupLoading: false,
        addGroupFormRules: {
          name: [
            {required: true, message: '请输入区域名称', trigger: 'blur'},
            { validator: validateWordAndNumberAndChinese, trigger: 'blur' }
          ],
        },
        //新增界面数据
        addGroupForm: {
          name: '',
        },

        editGroupFormVisible: false,//编辑界面是否显示
        editGroupLoading: false,
        editGroupFormRules: {
          name: [
            {required: true, message: '请输入区域名称', trigger: 'blur'},
            { validator: validateWordAndNumberAndChinese, trigger: 'blur' }
          ],
        },
        //编辑界面数据
        editGroupForm: {
          id: '',
          name: '',
        },
      }
    },
    filters: {
      name: ''
    },
    methods: {
      cleanFilter() {
        this.filters.name = '';
        this.getCompanies();
      },
      formatCity: function (row) {
        var city = this.cities.find(t => {
          return t.id == row.cityId;
        });
        if (city)
          return city.name;
        return '';
      },
      convertAddress() {
        if (this.addForm.address) {
          var url = 'http://api.map.baidu.com/geocoder/v2/?address=' + this.addForm.address + '&output=json&ak=bAouH2hDApj3TNU7dgK02jyx&callback=showLocation';
          this.$http.jsonp(encodeURI(url)).then(response => {
            this.addForm.lat = response.body.result.location.lat;
            this.addForm.lng = response.body.result.location.lng;
            this.addForm.center.lat = this.addForm.lat;
            this.addForm.center.lng = this.addForm.lng;
            // get body data
//          this.someData = response.body;

          }, response => {
            // error callback
          });
        }
      },
      convertAddress2() {

        if (this.editForm.address) {
          var url = 'http://api.map.baidu.com/geocoder/v2/?address=' + this.editForm.address + '&output=json&ak=bAouH2hDApj3TNU7dgK02jyx&callback=showLocation';
          this.$http.jsonp(encodeURI(url)).then(response => {
            this.editForm.lat = response.body.result.location.lat;
            this.editForm.lng = response.body.result.location.lng;
            this.editForm.center = {
              lat: response.body.result.location.lat,
              lng: response.body.result.location.lng,
            };
//            this.editForm.address = this.editForm.address + ' ';
            // get body data
//          this.someData = response.body;

          }, response => {
            // error callback
            console.log(response)
          });
        }
      },
      tableRowClassName(row, index) {
        return 'rowClass';
      },
      //性别显示转换
      formatStatus: function (row, column) {
        return row.status ? '在职' : '离职';
      },
      formatCreateTime: function (row, column) {
        return moment(row.createdAt).format('YYYY-MM-DD');
      },
      formatUpdateTime: function (row, column) {
        return moment(row.updatedAt).format('YYYY-MM-DD');
      },
      handleCurrentChange(val) {
        this.page = val;
        this.getCompanies();
      },
      handleCurrentChange2(val) {
        this.page2 = val;
        this.getGroups(this.selectedRow.id);
      },
      //获取企业列表
      getCompanies() {
        let para = {
          page: this.page,
          size: 10,
          name: this.filters.name
        };
        this.listLoading = true;
        //NProgress.start();
        getCompanyList(para).then((res) => {
          this.total = res.data.total;
          this.companies = res.data.list;
          this.listLoading = false;
          this.viewVisible = false;
          //NProgress.done();
        });
      },
      //获取企业列表
      getGroups(company) {
        let para = {
          page: this.page2,
          size: 10,
          companyId: company
        };
        //NProgress.start();
        getGroupList(para).then((res) => {
          this.total2 = res.data.total;
          this.groups = res.data.list;
          //NProgress.done();
        });
      },
      handleTick: function (index, row) {
        this.$confirm('确认踢出该用户吗?', '提示', {
          type: 'warning'
        }).then(() => {
          this.listLoading = true;
          //NProgress.start();
          kickUser({
            userId: row.id
          }).then((res) => {
            this.listLoading = false;
            //NProgress.done();
            this.$message({
              message: '踢出成功',
              type: 'success'
            });
//            this.getUsers();
          });
        }).catch(() => {

        });
      },
      //获取企业用户列表
      getUsers() {
        let para = {
          companyId: this.selectedRow.id
        };
        this.usersLoading = true;
        //NProgress.start();
        getUserList(para).then((res) => {
          this.users = res.data;
          this.usersLoading = false;
          //NProgress.done();
        });
      },
      //获取城市列表
      getCities() {
        let para = {};
        //NProgress.start();
        getCityList(para).then((res) => {
          this.total = res.data.total;
          this.cities = res.data.list;
          //NProgress.done();
        });
      },
      //获取用户组列表
      getRoles() {
        getRoleList().then((res) => {
          this.roles = res.data;
        });
      },
      //删除
      handleDel: function (index, row) {
        this.$confirm('确认删除该记录吗?', '提示', {
          type: 'warning'
        }).then(() => {
          this.listLoading = true;
          //NProgress.start();
          removeCompany(row.id).then((res) => {
            this.listLoading = false;
            //NProgress.done();
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.getCompanies();
          });
        }).catch(() => {

        });
      },
      //删除用户
      handleDelUser: function (index, row) {
        this.$confirm('确认删除该记录吗?', '提示', {
          type: 'warning'
        }).then(() => {
          this.usersLoading = true;
          //NProgress.start();
          removeUser(row.id).then((res) => {
            this.usersLoading = false;
            //NProgress.done();
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.getUsers();
          });
        }).catch(() => {

        });
      },
      handleDelGroup: function (index, row) {
        this.$confirm('确认删除该记录吗?', '提示', {
          type: 'warning'
        }).then(() => {
          this.groupsLoading = true;
          //NProgress.start();
          removeGroup(row.id).then((res) => {
            this.groupsLoading = false;
            //NProgress.done();
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.getGroups(this.selectedRow.id);
          });
        }).catch(() => {

        });
      },
      //显示编辑界面
      handleEdit: function (index, row) {
        this.editFormVisible = true;
        this.editForm = Object.assign({}, row);
        this.editForm.center = {
          lat: row.lat,
          lng: row.lng,
        };
        return true;
      },
      handleEditUser: function (index, row) {
        this.editUserFormVisible = true;
        this.editUserForm = Object.assign({}, row);
      },
      handleEditGroup: function (index, row) {
        this.editGroupFormVisible = true;
        this.editGroupForm = Object.assign({}, row);
      },
      //显示新增界面
      handleAdd: function () {
        this.addFormVisible = true;
        if (this.$refs['addForm']) {
          this.$refs['addForm'].resetFields();
        }
        this.addForm = {
          name: '',
          alias: '',
          cityId: '',
          address: '',
          lat: '',
          lng: '',
          center: {lng: 116.404, lat: 39.915},
          contactName: '',
          contactPhone: '',
        };
      },
      //显示新增用户界面
      handleAddUser: function () {
        this.addUserFormVisible = true;
        if (this.$refs.addUserForm) {
          this.$refs.addUserForm.resetFields();
        }
        this.addUserForm = {
          name: '',
          cityId: '',
          address: '',
          lat: '',
          lng: '',
          contactName: '',
          contactPhone: '',
        };
      },
      //显示新增区域界面
      handleAddGroup: function () {
        this.addGroupFormVisible = true;
        if (this.$refs.addGroupForm) {
          this.$refs.addGroupForm.resetFields();
        }
        this.addGroupForm = {
          name: '',
        };
      },
      rowClick: function (row, event, column) {
        this.selectedRow = row;
        this.viewVisible = true;
        this.getUsers();
        this.getGroups(row.id);
      },
      //编辑
      editSubmit: function () {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.editLoading = true;
              //NProgress.start();
              let para = {
                id: this.editForm.id,
                name: this.editForm.name,
                alias: this.editForm.alias,
                cityId: this.editForm.cityId,
                address: this.editForm.address.trim(),
                lat: this.editForm.lat,
                lng: this.editForm.lng,
                contactName: this.editForm.contactName,
                contactPhone: this.editForm.contactPhone,
              };
              editCompany(para).then((res) => {
                this.editLoading = false;
                //NProgress.done();
                this.$message({
                  message: '提交成功',
                  type: 'success'
                });
                this.$refs['editForm'].resetFields();
                this.editFormVisible = false;
                this.getCompanies();
              });
            });
          }
        });
      },
      //编辑用户
      editUserSubmit: function () {
        this.$refs.editUserForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.editUserLoading = true;
              //NProgress.start();
              let para = {
                id: this.editUserForm.id,
                name: this.editUserForm.name,
                username: this.editUserForm.username,
                email: this.editUserForm.email,
                phone: this.editUserForm.phone
              };
              if (!!this.editUserForm.password) {
                para.password = this.editUserForm.password;
              }
              editUser(para).then((res) => {
                this.editUserLoading = false;
                //NProgress.done();
                this.$message({
                  message: '提交成功',
                  type: 'success'
                });
                this.$refs['editUserForm'].resetFields();
                this.editUserFormVisible = false;
                this.getUsers();
              });
            });
          }
        });
      },
      editGroupSubmit: function () {
        this.$refs.editGroupForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.editGroupLoading = true;
              //NProgress.start();
              let para = {
                id: this.editGroupForm.id,
                name: this.editGroupForm.name,
              };
              editGroup(para).then((res) => {
                this.editGroupLoading = false;
                //NProgress.done();
                this.$message({
                  message: '提交成功',
                  type: 'success'
                });
                this.$refs['editGroupForm'].resetFields();
                this.editGroupFormVisible = false;
                this.getGroups(this.selectedRow.id);
              });
            });
          }
        });
      },
      //新增
      addSubmit: function () {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.addLoading = true;
              //NProgress.start();
              let para = Object.assign({}, this.addForm);
              addCompany(para).then((res) => {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: '提交成功',
                  type: 'success'
                });
                this.$refs['addForm'].resetFields();
                this.addFormVisible = false;
                this.getCompanies();
              });
            });
          }
        });
      },
      //新增用户
      addUserSubmit: function () {
        this.$refs.addUserForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.addUserLoading = true;
              //NProgress.start();
              let para = Object.assign({}, this.addUserForm);
              para.companyId = this.selectedRow.id;
              addUser(para).then((res) => {
                this.addUserLoading = false;
                //NProgress.done();
                this.$message({
                  message: '提交成功',
                  type: 'success'
                });
                this.$refs['addUserForm'].resetFields();
                this.addUserFormVisible = false;
                this.getUsers();
              });
            });
          }
        });
      },
      addGroupSubmit: function () {
        this.$refs.addGroupForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.addGroupLoading = true;
              //NProgress.start();
              let para = Object.assign({}, this.addGroupForm);
              para.companyId = this.selectedRow.id;
              addGroup(para).then((res) => {
                this.addGroupLoading = false;
                //NProgress.done();
                this.$message({
                  message: '提交成功',
                  type: 'success'
                });
                this.$refs['addGroupForm'].resetFields();
                this.addGroupFormVisible = false;
                this.getGroups(this.selectedRow.id);
              });
            });
          }
        });
      },
    },
    mounted() {
      this.getCompanies();
      this.getCities();
    },
    components: {
      BaiduMap,
      BmMarker
    },
  }

</script>

<style scoped>
  .mapView {
    width: 100%;
    height: 200px;
  }
</style>



// WEBPACK FOOTER //
// Company.vue?0fd9efa9